import React, {Component} from 'react';
import {Redirect} from "react-router";

class RedirectOnlyHome extends Component {
    constructor(props) {
        super(props);
        this.state = {redirect: window.redirectOnlyHome};
        if (window.redirectOnlyHome)
            window.redirectOnlyHome = !window.redirectOnlyHome;
    }
    render() {
        if (this.state.redirect)
            return <Redirect push to='/' />;
        else
            return '';
    }
}

export default RedirectOnlyHome;